import * as moment from 'moment';

export const activityDatesDropdownOptions = (): Array<{
  key: string;
  value: string;
  label: string;
}> => {
  const formatting = 'YYYY-MM-DD';
  const now = moment();

  const oldDateString = '1901-01-01';

  return [
    {
      key: 'all',
      value: '0',
      label: 'All',
    },
    {
      key: 'last7days',
      value:
        now.clone().subtract(7, 'days').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last 7 days',
    },
    {
      key: 'last10days',
      value:
        now.clone().subtract(10, 'days').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last 10 days',
    },
    {
      key: 'last2weeks',
      value:
        now.clone().subtract(2, 'weeks').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last 2 weeks',
    },
    {
      key: 'last1months',
      value:
        now.clone().subtract(1, 'months').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last month',
    },
    {
      key: 'last2months',
      value:
        now.clone().subtract(2, 'months').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last 2 months',
    },
    {
      key: 'last6months',
      value:
        now.clone().subtract(6, 'months').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last 6 months',
    },
    {
      key: 'last12months',
      value:
        now.clone().subtract(1, 'years').format(formatting) +
        '/' +
        now.clone().add(1, 'days').format(formatting),
      label: 'Last completed activity in last year',
    },
    {
      key: 'lastolderthan7days',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(7, 'days').format(formatting),
      label: 'Last completed activity older than 7 days',
    },
    {
      key: 'lastolderthan10days',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(10, 'days').format(formatting),
      label: 'Last completed activity older than 10 days',
    },
    {
      key: 'lastolderthan2weeks',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(2, 'weeks').format(formatting),
      label: 'Last completed activity older than 2 weeks',
    },
    {
      key: 'lastolderthan1month',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(1, 'months').format(formatting),
      label: 'Last completed activity older than a month',
    },
    {
      key: 'lastolderthan2months',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(2, 'months').format(formatting),
      label: 'Last completed activity older than 2 months',
    },
    {
      key: 'lastolderthan6months',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(6, 'months').format(formatting),
      label: 'Last completed activity older than 6 months',
    },
    {
      key: 'lastolderthan1year',
      value:
        oldDateString +
        '/' +
        now.clone().subtract(1, 'years').format(formatting),
      label: 'Last completed activity older than 1 year',
    },
    {
      key: 'no-activities',
      value: '-1',
      label: 'Leads with no activities ever created',
    },
  ];
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/data/sales/leadsActivityDateFilter.ts